/* <cart-page>: the cart form of sections/main-cart.liquid. Quantity changes,
   re-rendering and Checkout blocking come from assets/cart-lines.js, which the
   section loads first; this element only keeps the order note across renders. */

if (!customElements.get('cart-page')) {
  customElements.define(
    'cart-page',
    class CartPage extends window.AsansaraCartLines {
      // The note is only saved when the form is posted, so a re-render must not drop what was typed.
      replace(fresh) {
        const note = this.querySelector('[name="note"]');
        super.replace(fresh);
        const freshNote = this.querySelector('[name="note"]');
        if (note && freshNote) freshNote.value = note.value;
      }
    },
  );
}
